import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from '@mui/material';

// Save a completed run as a new portfolio or over an existing one. Saving only
// references the run's receipt; the backend binds the saved configuration.
export default function OptimizerSaveDialog({
    open,
    onClose,
    listOfWhatIfPortfolios = [],
    onSave,
}) {
    const [manualInput, setManualInput] = useState('');
    const [dropdownValue, setDropdownValue] = useState('');
    const [manualInputError, setManualInputError] = useState('');

    const reset = () => {
        setManualInput('');
        setDropdownValue('');
        setManualInputError('');
    };
    const handleManualInputChange = (event) => {
        const value = event.target.value;
        setManualInput(value);
        const trimmedValue = value.trim();
        if (!trimmedValue) {
            setManualInputError('Portfolio name is required');
        } else if (trimmedValue.toLowerCase() === 'pos-sizing') {
            setManualInputError("Cannot use 'pos-sizing' as a value");
        } else {
            setManualInputError('');
        }
    };
    const handleConfirm = () => {
        const finalValue = (dropdownValue || manualInput).trim();
        if (!dropdownValue && !finalValue) {
            setManualInputError('Portfolio name is required');
            return;
        }
        if (manualInputError && !dropdownValue) return;
        onSave(finalValue, !dropdownValue);
        reset();
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Save Optimizer Details</DialogTitle>
            <DialogContent>
                <FormControl fullWidth margin="normal" variant="outlined">
                    <InputLabel id="optimizer-save-dropdown-label">
                        Select What If Portfolio
                    </InputLabel>
                    <Select
                        labelId="optimizer-save-dropdown-label"
                        value={dropdownValue}
                        label="Select What If Portfolio"
                        onChange={(event) => {
                            setDropdownValue(event.target.value);
                            setManualInputError('');
                        }}
                    >
                        {listOfWhatIfPortfolios.map((option) => (
                            <MenuItem key={option.id ?? option.value} value={option.value}>
                                {option.value}
                            </MenuItem>
                        ))}
                    </Select>
                    {dropdownValue && (
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                            <Button
                                size="small"
                                onClick={() => {
                                    setDropdownValue('');
                                    setManualInputError('');
                                }}
                            >
                                Clear Selection
                            </Button>
                        </Box>
                    )}
                </FormControl>
                <TextField
                    fullWidth
                    margin="normal"
                    label="Enter Value"
                    variant="outlined"
                    value={dropdownValue || manualInput}
                    onChange={handleManualInputChange}
                    disabled={Boolean(dropdownValue)}
                    error={Boolean(manualInputError)}
                    helperText={manualInputError || ' '}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    disabled={Boolean(manualInputError)}
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
}

OptimizerSaveDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    listOfWhatIfPortfolios: PropTypes.array,
    onSave: PropTypes.func.isRequired,
};
